// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4cd77f13","609":"c4628a95","625":"f5641c1a","649":"54893cbb","652":"1b374ac7","674":"f999674c","863":"55cfb5e0","872":"68c32d97","900":"86e14a95"}[chunkId] + ".chunk.js";
};